module.exports = __webpack_public_path__ + "static/m-IMendoza-8ba53f5c6099477d1d1e72476ab3c375.jpg";